import React from "react";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import PerformacePage from "../container/PerformacePage";
const Routes = () => (
   <Router>
    <ToastContainer />
    <Switch>
      <Route path="/audit-report/:id" component={PerformacePage}  exact/>
      <Route component={() => <div>404</div>} />
    </Switch>
  </Router>
);

export default Routes;
